import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spaceSeparator',
})
export class SpaceSeparatorPipe implements PipeTransform {
  transform(value: number | string): string {
    if (typeof value === 'string') {
      value = parseFloat(value);
    }
    if (isNaN(value)) {
      return '';
    }

    const formattedValue = value.toLocaleString('en-US', {
      useGrouping: true,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });

    return formattedValue.replace(',', ' ');
  }
}
